import { render, staticRenderFns } from "./carbonfactor.vue?vue&type=template&id=3c89492e&"
import script from "./carbonfactor.vue?vue&type=script&lang=ts&"
export * from "./carbonfactor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "carbonfactor.vue"
export default component.exports